var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2","y1":"18.9724","x2":"18.9706","y2":"2.00187","stroke":"#02183C","strokeWidth":"3","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"2.12132","y1":"2.09375","x2":"19.0919","y2":"19.0643","stroke":"#02183C","strokeWidth":"3","strokeLinecap":"round","key":1})]);
}

CloseIcon.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
